export default __webpack_public_path__ + "static/media/models9.83e32752.jfif";